import React from 'react'
import { post } from 'client/utils/api-routes.util'
import { OrdersContext } from 'contexts/OrdersContext'
import {
  DcButton,
  DcDropDown,
  DcInput,
  PixelFactoryContext,
  PixelFlexBox,
  PixelTag,
  DcForm,
  DcFlexBox,
  SectionContent,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'

import { IDispatch } from '../../../../../../../decl'
import { IPixelFactory } from '../../../../../../../decl.d'

interface IProps {
  dispatches: IDispatch[]
  selectedDispatch: IDispatch
  handleClose: (data: IDispatch) => void
  origin: string
}
const ResendOrderPopup = (props: IProps) => {
  const {
    dispatches,
    selectedDispatch,
    handleClose,
    origin = 'received',
  } = props

  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { state: ordersState } = React.useContext(OrdersContext)

  const [activeDispatch, setActiveDispatch] = React.useState<IDispatch>({
    dispatch_id: 0,
    dispatch_name: '',
    ems_customer_id: 0,
    courier_id: '',
    courier_reference: null,
    created_at: new Date(),
    created_at_gmt: new Date(),
    status: '',
    status_close_time: null,
    total_pieces: '',
    total_packages: '',
    total_prepaid_packages_count: '',
    total_cod_amount: '',
    courier_name: '',
    warehouse_id: 0,
    warehouse_name: '',
  })

  const [data, setData] = React.useState<{
    dispatch_id: string
    dispatch_name: string
    warehouse_id: number
  }>({
    dispatch_id: '0',
    dispatch_name: '',
    warehouse_id: 0,
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const handleSubmit = (e) => {
    e.preventDefault()
    if (origin == 'received') {
      showPageLoader()
      // const { dispatch_id } = data
      const dispatch = {
        dispatch_name: data.dispatch_name,
        return_order_id: selectedDispatch?.id,
        return_batch_id: selectedDispatch?.return_batch_id,
        warehouse_id:
          data?.dispatch_id == '0'
            ? data.warehouse_id
            : activeDispatch.warehouse_id,
        tracking_id: selectedDispatch?.tracking_id,
        dispatch_id: data?.dispatch_id,
      }
      if (data?.dispatch_id == '0') {
        if (data.warehouse_id == 0) {
          setError({
            error: 'Please select a warehouse',
            field: 'warehouse_id',
          })
          hidePageLoader()
          return
        }
      }
      post(
        `/order/returns/${selectedDispatch.number}/dispatch`,
        dispatch,
      ).subscribe((res: AjaxResponse<any>) => {
        hidePageLoader()
        if (res.response.error) {
          showFailure(res.response.error)
        } else {
          showSuccess('Successfully Dispacthed!')
          handleClose()
        }
      })
    } else {
      handleClose({
        dispatch_name: data.dispatch_name,
        warehouse_id:
          data?.dispatch_id == '0'
            ? data.warehouse_id
            : activeDispatch.warehouse_id,
        dispatch_id: data.dispatch_id,
      })
    }
  }
  return (
    <SectionContent>
      <DcForm onSubmit={handleSubmit}>
        <DcFlexBox flexDirection="column" gap="10px" height="auto">
          <h6>A new tracking id will be assigned to the order</h6>
          <DcDropDown
            label="A new tracking id will be assigned to the order"
            error={
              error.field === 'dispatch_id' && error.error !== ''
                ? error.error
                : null
            }
            required
            value={data.dispatch_id}
            options={[
              {
                label: 'New Dispatch',
                value: '0',
              },
              ...dispatches.map((dispatch) => ({
                label: `${dispatch.courier_name} - ${dispatch.created_at} #${dispatch.dispatch_id}`,
                value: dispatch.dispatch_id,
              })),
            ]}
            onChange={(e) => {
              setData({ ...data, dispatch_id: e.target.value })
              if (e.target.value != '0') {
                const activeDispatch = dispatches.find(
                  (dispatch) => dispatch.dispatch_id == e.target.value,
                )
                setActiveDispatch(activeDispatch)
              }
            }}
          />

          {data?.dispatch_id == '0' && (
            <>
              {' '}
              <DcInput
                required
                value={data.dispatch_name}
                placeholder="Dispatch Name"
                onChange={(e) => {
                  setData({ ...data, dispatch_name: e.target.value })
                }}
              />
              <DcDropDown
                placeholder="Select Warehouse"
                required
                error={
                  error.field === 'warehouse_id' && error.error !== ''
                    ? error.error
                    : null
                }
                value={data.warehouse_id}
                options={[
                  {
                    value: null,
                    label: 'Select Warehouse',
                  },

                  ...ordersState.warehouses.map((w) => {
                    return {
                      value: w['wh_id'],
                      label: w['name'],
                    }
                  }),
                ]}
                onChange={(e) => {
                  setData({ ...data, warehouse_id: e.target.value })
                  setError({
                    error: '',
                    field: '',
                  })
                }}
              />
            </>
          )}

          {data?.dispatch_id != '0' && (
            <>
              <PixelFlexBox
                flexWrap="wrap"
                justifyContent="flex-start"
                alignItems="flex-start"
                alignContent="flex-start"
                height="auto"
              >
                Dispatch Name:<strong> {activeDispatch.dispatch_name}</strong>
              </PixelFlexBox>
              <PixelFlexBox
                flexWrap="wrap"
                justifyContent="flex-start"
                alignItems="flex-start"
                alignContent="flex-start"
                height="auto"
              >
                Dispatch ID:<strong> {activeDispatch.dispatch_id}</strong>
              </PixelFlexBox>
              <PixelFlexBox
                flexWrap="wrap"
                justifyContent="flex-start"
                alignItems="flex-start"
                alignContent="flex-start"
                height="auto"
              >
                Dispatch Status:<PixelTag>{activeDispatch?.status}</PixelTag>
              </PixelFlexBox>
              <PixelFlexBox
                flexWrap="wrap"
                justifyContent="flex-start"
                alignItems="flex-start"
                alignContent="flex-start"
                height="auto"
              >
                Dispatch Warehouse:
                <strong> {activeDispatch?.warehouse_name}</strong>
              </PixelFlexBox>
            </>
          )}
        </DcFlexBox>
        <DcFlexBox flexDirection="row" gap="10px" height="auto">
          <DcButton type={'submit'}>Yes</DcButton>
        </DcFlexBox>
      </DcForm>
    </SectionContent>
  )
}

export default ResendOrderPopup
